module.exports = __webpack_public_path__ + "3f6e7bd69ce5d0a73036d898803a2d0f.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/icon/phone.svg
// module id = 2042
// module chunks = 0